export default {
  "group": "Group",
  "report": "Report",
  "lastDataReportPvt": "Last Cognus evaluation",
  "lastDataReportSleep": "Last FFD evaluation",
  "lastWeekReport": "Last week",
  "lastMonthReport": "Last month",
  "lastThreeMonthsReport": "Last three months",
  "lastSixMonthsReport": "Last six months",
  "lastYearReport": "Last year",
  "workShiftGroup": "Shift group",
  "reportGroup": "Summarized report by",
  "operations": "Operation",
  "client": "Client",
  "zone": "Zone",
  "carrier": "Carrier",
  "carriers": "Carriers",
  "plant": "Plant",
  "from": "From",
  "to": "To",
  "user": "User",
  "closeSession": "Log out",
  "profile": "Profile",
  "noTags": "No Tags",
  "person": "Person",
  "plantClient": "Geo-zones",
  "search": "Search",
  "synchrousDate": "Synchronization date",
  "inspectionDate": "Inspection date",
  "filterFor": "Filter by",
  "date": "Date",
  "inspector": "Inspector",
  "note": "Grade",
  "type": "Type",
  "subtype": "Subtype",
  "form": "Form",
  "transporter": "Carrier",
  "driver": "Driver",
  "team": "Equipment",
  "fails": "Failures",
  "nodata": "There’s no more data",
  "indicators": "All carriers indicator",
  "FFDResult": "Results summary",
  "FFDSync": "Synchronization rate",
  "FFDRealization": "Realization rate",
  "show": "Display",
  "ffdPvt": "Cognus",
  "ffdSleep": "FFD",
  "sleepWristband": "Sleepiness bracelets",
  "pvtTest": "PVT Test",
  "help": "Help",
  "repeatTour": "Repeat tour",
  "categoryFilters": "Category filters",
  "cancel": "Cancel",
  "apply": "Apply",
  "ubicationpvt": "PVT Location",
  "contract": "Contract",
  "typeFilters": "Type / Subtype",
  "customize": "Customize",
  "and": "and",
  "more": "more",
  "all": "ALL",
  "noMatches": "There are no matches"
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/filters/index.js